import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { Gate } from './SignIn';
import './style.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

// Plan 044: a new build installs as soon as it is found, so a fix reaches an installed app on its next check instead of
// waiting for someone to accept a prompt.
const applyUpdate = registerSW({ immediate: true, onNeedRefresh() { void applyUpdate(true); } });
window.addEventListener('desk-apply-update', () => { void applyUpdate(true); });
// iOS Safari ignores user-scalable=no in a browser tab; cancelling its gesture events stops whole-page pinch zoom.
// The chart's pinch comes from touch events, which this leaves alone (plan 017).
for (const type of ['gesturestart', 'gesturechange']) document.addEventListener(type, e => e.preventDefault(), { passive: false });
createRoot(document.getElementById('root')!).render(<React.StrictMode><Gate><App/></Gate></React.StrictMode>);
